import React, { useCallback, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import Cookies from 'js-cookie';

import { LocalStorageService } from '../../services/localStorageService';
import { login } from '../../actions/sessionActions';
import { localStorageKeys } from '../../constants/localStorageKeys';
import { screenRoutes } from '../../constants/routesPath';

const ClientSSORedirect = ({ location }: any) => {
	const { token, accountId } = useParams<any>();
	const history = useHistory();
	const dispatch = useDispatch<any>();
	const { i18n } = useTranslation();
	const { isLoggedIn } = useSelector((state: any) => state.session);

	const searchParams = new URLSearchParams(location.search);
	const redirectRoute = decodeURIComponent(searchParams.get('redirectRoute') || '');

	const setLanguageFromParams = useCallback(() => {
		const lang = (queryString.parse(location.search)?.lang) as string;
		if (!lang || lang === i18n.language) {
			return;
		}
		Cookies.set('selected_language', lang, { expires: 365 });
		i18n.changeLanguage(lang);
	}, [i18n, location.search]);

	useEffect(() => {
		if (!token || !accountId) {
			history.push(screenRoutes.LOGIN_FAILED);
			return;
		}

		if (isLoggedIn) {
			setLanguageFromParams();
			if (redirectRoute) {
				window.open(redirectRoute, '_self');
			} else {
				history.push('/');
			}
			return;
		}

		LocalStorageService.addItem(localStorageKeys.DEFAULT_ACCOUNT_ID, accountId);
		LocalStorageService.addItem(localStorageKeys.ACCESS_TOKEN, token);

		dispatch(login(token, accountId))
			.then((result: any) => {
				if (result instanceof Error) {
					history.push(screenRoutes.LOGIN_FAILED);
					return;
				}

				const verifiedAccountId = localStorage.getItem(localStorageKeys.DEFAULT_ACCOUNT_ID);
				if (!verifiedAccountId) {
					history.push(screenRoutes.LOGIN_FAILED);
					return;
				}

				setLanguageFromParams();
				if (redirectRoute) {
					window.open(redirectRoute, '_self');
				} else {
					history.push(screenRoutes.PUBLISH_MEDIA_LIBRARY);
				}
				localStorage.removeItem(localStorageKeys.USER_ACCESS_LINK_BEFORE_REDIRECT);
			})
			.catch(() => {
				history.push(screenRoutes.LOGIN_FAILED);
			});
	}, [isLoggedIn, token, accountId, history, dispatch, redirectRoute, setLanguageFromParams]);

	return <div></div>;
};

export default ClientSSORedirect;
